(function () {
  var optins =
    window.optinNames || (window.optinName ? [window.optinName] : []);

  optins.forEach(function (optinName) {
    window.quickFetch.makeEarlyRequest('optin-' + optinName, {
      url: window.quickFetch.getApiUrl('/optins/v1/availability/' + optinName),
      timeout: 15000,
      dataType: 'json',
      contentType: 'application/json',
      type: 'GET',
      whenFinished: function (availability) {
        availability.optinView =
          availability.state === 'OPTED_IN' ? 'NEW' : 'CURRENT';
      },
    });
  });
})();
